import React, { useEffect } from 'react'
import Skeleton from 'react-loading-skeleton'
import Breadcrumbs from '../components/Breadcrumbs'
import { Link } from 'react-router-dom';
// import Skeleton from 'react-loading-skeleton'

const Header_2 = ({ module={}, isLoading=true, title, description, image, sectionClass, activePage, activeInnerPage, sendTitle = true, bgGray = false, sticker = false, stickerColor = "orange", directImage=false}) => {

    const breakLine = (text) => {
        return text.split("\n").map((line, index) => (
            <React.Fragment key={index}>
                {line}
                {index !== text.split("\n").length - 1 && <br />}
            </React.Fragment>
        ));
    };

    useEffect(() => {
        console.log('Header_2 module data:', module);
    }, [])

    return (
        <>
            <section className={`banner_sec inner_banner ${sectionClass} position-relative`}>


                <div className='img-positon'>

                    {module?.Bild_oder_Video === "Video" ? (
                        <video
                            src={`https://backend.bgzurlinden.ch${module?.Video?.url}`}
                            className="header-video position-static"
                            autoPlay
                            loop
                            muted
                            playsInline
                            webkit-playsinline="true"
                            preload="auto"
                            poster={`https://backend.bgzurlinden.ch${module?.Videominiatur?.url}`}
                        >
                        </video>
                    ) : (
                        <img src={!directImage ? `https://backend.bgzurlinden.ch${image?.url}` : image} className='w-100' alt='#' />
                    )}


                </div>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                            {isLoading ? (
                                <h1>{<Skeleton count={1} />}</h1>

                            ) : (
                                <h1 className='text-black line-before position-relative' lang="de">{breakLine(title)}</h1>
                            )}
                            {/* {description && (
                                <p>
                                    {description.length > 100
                                        ? `${description.slice(0, 100)}...`
                                        : description}
                                </p>
                            )} */}
                            {description && <p>{description}</p>}
                        </div>
                    </div>
                </div>
            </section>

            {sticker && <section>
                <div className="container position-relative">
                    <div class="termin-btn">
                        <Link to={'/reparaturmeldung'}>
                            <div class={`rotating-booking ${stickerColor === "blue" ? "blue-sticker" : "orange-sticker"}`}>
                                <img src={stickerColor === "orange" ? "https://backend.bgzurlinden.ch/uploads/reparaturmeldung_icon_b1b44a1d2a.svg" : "https://backend.bgzurlinden.ch/uploads/reparaturmeldung_icon_blue_6c741e7edd.svg"} alt="#" />
                            </div>
                            {/* <img src="/images/new-zahlen-icon-2.svg" class="termin_center_icon" /> */}
                        </Link>
                    </div>
                </div>
            </section>}

            {activePage && <div className={`page-breadcrumb pt-5 pb-3 ${bgGray ? 'sec-bg-grey' : ''}`}>
                <Breadcrumbs buttonText={sendTitle ? title : ''} activePage={activePage} activeInnerPage={activeInnerPage} sectionClass={sectionClass} bgGray={bgGray} />
            </div>}
        </>

    )
}

export default Header_2